// apiDataService.js
import { httpService } from "./method/httpsService";
import { websocketService } from "./method/webSocketService";
import { sseService } from "./method/sseService";

// const METHOD = import.meta.env.VITE_API_METHOD || "http";
const METHOD = process.env.VUE_APP_METHOD || "http";

let selectedService;

switch (METHOD) {
	case "websocket":
		selectedService = websocketService;
		break;
	case "sse":
		selectedService = sseService;
		break;
	default:
		selectedService = httpService; // fallback
}

export const apiDataService = selectedService;
